import { Navigate, useParams } from 'react-router-dom';

export function RedirectCommercialLoanHubToLoan() {
  return <Navigate to="/loan" replace />;
}

export function RedirectCommercialLoanAppToLoan() {
  const { applicationId } = useParams<{ applicationId: string }>();
  if (!applicationId) return <Navigate to="/loan" replace />;
  return <Navigate to={`/loan/${applicationId}`} replace />;
}

export function RedirectProfileLoanTypeToLoan() {
  return <Navigate to="/loan/loan-type" replace />;
}

export function RedirectProfileQualificationsToLoan() {
  return <Navigate to="/loan/qualifications" replace />;
}

export function RedirectProfileLoanStatusToLoan() {
  return <Navigate to="/loan#loan-status" replace />;
}

export function RedirectProfileDocumentsToLoan() {
  return <Navigate to="/documents" replace />;
}
